import { Fragment, useEffect, useState } from "react"
import { useStore } from "../../../../Contexts/GlobalStoreContext"
import EditTableRow, { EditTableCellCreateFn } from "./EditTableRow"
import TableRow from "./TableRow"
import React from "react"
import { TBody } from "./StyledComponents/TableStyleComp"
import {
	TOnClickTableRow,
	TSelectedTableRowId,
} from "components/ProjectSpecificComponents/Interfaces/TableInterface"
import { JSX_TYPES } from "@babel/types"

interface Props {
	data: any[]
	editTableCell?: EditTableCellCreateFn
	tableRow: any
	editable: boolean
	head: any[]
	clickedOnRow?: TOnClickTableRow
	currentPage: number
	AddNewRecordRow?: any
	tableRowStyle: React.CSSProperties | undefined
	bodyHeight: string
}

const TableBody = ({
	data,
	editTableCell,
	tableRow,
	editable = true,
	head,
	clickedOnRow,
	currentPage,
	AddNewRecordRow,
	tableRowStyle,
	bodyHeight,
}: Props) => {
	const store = useStore()
	const [internalSelectedRowId, setSelectedRowId] = useState<TSelectedTableRowId | undefined>()

	useEffect(() => {
		return () => {
			setSelectedRowId(undefined)
		}
	}, [])
	return (
		<TBody style={{ minHeight: 100, maxHeight: bodyHeight }}>
			{currentPage == 1 && AddNewRecordRow}
			{data?.map((row: any, i: number) => {
				let rowId = row.id ?? i

				return (
					<Fragment key={rowId}>
						{internalSelectedRowId === rowId && editTableCell && editable ? (
							<EditTableRow
								key={rowId}
								row={row}
								head={head}
								editTableCell={editTableCell}
								selectedRowId={internalSelectedRowId}
								onBlur={() => setSelectedRowId(undefined)}
							/>
						) : (
							<TableRow
								key={rowId}
								row={row}
								rowId={rowId}
								i={i}
								tableRow={tableRow}
								selectedRowId={internalSelectedRowId}
								showPointer={!!clickedOnRow}
								onClick={(e) => {
									const tdElement: HTMLElement = e.target
									const cellOffsetLeft = tdElement.offsetLeft

									// Wait 10ms,
									// in order to allow the previous blur effect fully finish
									setTimeout(() => {
										typeof clickedOnRow == "function" && clickedOnRow(rowId, row)
										setSelectedRowId(rowId)

										store.setHoveredCellOffsetLeft(cellOffsetLeft)
										store.setIsTableCellInputFocused(true)
									}, 10)
								}}
								style={{
									...tableRowStyle,
								}}
								className={`color-nth-row`}
							/>
						)}
					</Fragment>
				)
			})}
		</TBody>
	)
}

export default TableBody
